import EnterOtp from "./EnterOtp";
import Enable2FA from "./Enable2FA";
import AuthCard from "./AuthCard";
import Personal from "./Personal";
import Enterprise from "./Enterprise";
import LockForm from "./LockForm";

const authComponents = {
  EnterOtp,
  Enable2FA,
  AuthCard,
  Personal,
  Enterprise,
  LockForm
}

export default authComponents